import { render, staticRenderFns } from "./commentSuccess.vue?vue&type=template&id=2c1aea94&scoped=true&"
import script from "./commentSuccess.vue?vue&type=script&lang=js&"
export * from "./commentSuccess.vue?vue&type=script&lang=js&"
import style0 from "./commentSuccess.vue?vue&type=style&index=0&id=2c1aea94&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1aea94",
  null
  
)

export default component.exports